import {
  Launch as LaunchIcon,
} from '@mui/icons-material';
import { Box, Card, Divider, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledComponent } from 'src/components/styled-components/styledComponent';
import HttpServices from 'src/services/httpService';
import { postsModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import SnapChat_Icon from '../../../assets/snapchat.svg';
import SnapchatPostCard from '../publishedPostsPostCard/SnapChatPostCard.component';

const SnapchatPostDetailView = ({ post, profile,viewType, height }) => {
  const { t: translate } = useTranslation();
  const { showToast } = useToaster();
  const [postDetails, setPostDetails] = useState(null);
  const [showLoader, setLoader] = useState(true);

  useEffect(() => {
    getPostDetails();
  }, [post?.id]);

  const snapchatPostDetailsSuccessCallback = (data) => {
    setPostDetails(data);
    setLoader(false);
  };

  const snapchatPostDetailsFailureCallback = (message) => {
    setPostDetails(null);
    message && showToast(message, 'e');
    setLoader(false);
  };

  const getPostDetails = () => {
    setLoader(true);
    let baseUrl;
    switch (viewType) {
      case 'spotlight':
        baseUrl = postsModuleURL.snapchatSportlightDetails;
        break;
      case 'saved_story':
        baseUrl = postsModuleURL.snapchatSavedStoryDetails;
        break;
      default:
        baseUrl = postsModuleURL.snapchatPostDetails;
        break;
    }

    let getProps = {
      url: `${baseUrl}${profile.id}&post_id=${post.id}`,
      successCallback: snapchatPostDetailsSuccessCallback,
      failureCallback: snapchatPostDetailsFailureCallback,
    };
    HttpServices.Get(getProps);
  };

  return (
    <StyledComponent.StyledStack sx={{ width: 800 }}>
      <Box sx={{ position: 'fixed', width: 800, zIndex: 1000, background: 'white', pb: 1 }}>
        <Grid alignItems="center" display="flex" sx={{ p: 2 }}>
          <img alt="Snapchat" width={40} height={40} src={SnapChat_Icon} />
          <Typography sx={{ ml: 2, fontSize: 24, fontWeight: 800 }}>{translate('snapchat_published_post.snapchat')}</Typography>
          
          {postDetails?.link && (
            <a href={postDetails.link} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 'auto' }}>
              <LaunchIcon sx={{ fontSize: 28, color: 'primary.main' }} />
            </a>
          )}
        </Grid>
        <Divider />
      </Box>

      <Box sx={{ mt: '6.5rem' }}>
        {showLoader ? (
          <Spinner height={height} />
        ) : (
          <Grid container justifyContent="center">
            <SnapchatPostCard 
              post={postDetails || post} 
              profile={profile} 
            />
          </Grid>
        )}
      </Box>
    </StyledComponent.StyledStack>
  );
};

export default SnapchatPostDetailView;